import React, { Component } from "react";
import "font-awesome/css/font-awesome.min.css";
import setIcon from "../images/settings.svg";
import whatweofferImg from "../images/whatWeoffer-img.png";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import ppt1 from "../ppt/What-we-offer.pptx";
import "./AboutCLiQ.css";
class WhatWeOff extends Component {
  render() {
    return (
      <div className="main-container">
        <div className="container">
          <div className="row">
            <div className="col-sm-3">
              <div className="left-bar rounded h-100">
                <ul>
                  <li>
                    <Link to="/experiencezone/intergration-process">
                      <img src={setIcon} alt="" className="seticon" />
                      <span>Integration Process</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/experiencezone/what-we-offer" className="active">
                      <img src={setIcon} alt="" className="seticon" />
                      <span>What we Offer</span>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-sm-9">
              <div className="inner-content">
                <h1>What We Offer</h1>
                <p>
                  This section includes the various Omni Channel Suites that
                  TATA CLiQ offers you CliQ’s Training Centre
                </p>
                <div className="img-block">
                  <img src={whatweofferImg} alt="" className="img-fluid" />
                </div>
                <ul>
                  <li>
                    <strong>Ship from Store:</strong> According to the inventory
                    availability, online orders will be allocated to the store.
                    Store staff will process the orders. Tata CLiQ Logistics
                    team picks up and delivers the product to customer in QuiQ
                    Delivery.
                  </li>
                  <li>
                    <strong>CLiQ &amp; PiQ: </strong>Customer choose a store
                    online (Basis inventory availability), payd online and visit
                    the store to collect the product.
                  </li>
                  <li>
                    <strong>Return to Store:</strong> In addition online returns
                    option, Customer can choose to walk-in to a nearby store to
                    return the product. Store issues a credit note and customer
                    can buy an alternate product.
                  </li>
                  <li>
                    <strong>Order-in-store:</strong> If the Customer is at the
                    store, doesn’t find the product size that they are looking
                    for. Store staff can place order on behalf of customer at
                    Tata CLiQ OIS module.
                  </li>
                </ul>
                <form method="get" action={ppt1}>
                  <button type="submit" className="download-btn">
                    Download for more info
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default WhatWeOff;
